import { createFileRoute } from "@tanstack/react-router";
import { MainSidebar } from "../../components/sidebars/MainSidebar";
import { ErrorsDashboard } from "./-ErrorsDashboard";

function ErrorsPageWithSidebar() {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 overflow-auto">
        <ErrorsDashboard />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/admin/errors")({
  component: ErrorsPageWithSidebar,
});
